// Stub da biblioteca react-native-inappbrowser-reborn para uso web

export interface InAppBrowserOptions {
  modalEnabled?: boolean;
  showTitle?: boolean;
  enableUrlBarHiding?: boolean;
  enableDefaultShare?: boolean;
  forceCloseOnRedirection?: boolean;
  toolbarColor?: string;
  preferredBarTintColor?: string;
  preferredControlTintColor?: string;
}

export interface InAppBrowserResult {
  type: 'success' | 'cancel' | 'dismiss';
  url?: string;
}

export const InAppBrowser = {
  isAvailable: (): Promise<boolean> => Promise.resolve(false),

  open: (
    url: string,
    _options?: InAppBrowserOptions,
  ): Promise<InAppBrowserResult> => {
    window.open(url, '_blank');
    return Promise.resolve({type: 'dismiss'});
  },

  openAuth: (
    url: string,
    _redirectUrl: string,
    _options?: InAppBrowserOptions,
  ): Promise<InAppBrowserResult> => {
    window.open(url, '_blank');
    return Promise.resolve({type: 'dismiss'});
  },

  close: (): void => {},
  closeAuth: (): void => {},
};

export default InAppBrowser;
